export { default } from './QrCodeModal';
